import SettingsDashboard from "pages/settings/SettingsDashboard";

export default function Settings() {
    // return <ProfileComponent type="settings" />;
    return <SettingsDashboard/>;
}
